import { HighestProductBidsPerRateObject } from "@/common/contexts/FrontendAuctionContext";

export function isCurrentUserTopBidder(
  rateData: HighestProductBidsPerRateObject | undefined,
  currentUserCommandIds: readonly string[] | undefined
): boolean {
  const topBidderCommandId = rateData?.topBidderCommandId;
  return Boolean(topBidderCommandId && currentUserCommandIds?.includes(topBidderCommandId));
}

export function isBidOutbid(
  bidAmount: number | null | undefined,
  highestBidAmount: number | null | undefined,
  isCurrentUserTopBidder: boolean
): boolean {
  if (isCurrentUserTopBidder || !bidAmount || !highestBidAmount) {
    return false;
  }
  return bidAmount <= highestBidAmount;
}

export function getRateExtensionInfo(rateData: HighestProductBidsPerRateObject | undefined): {
  isExtended: boolean;
  effectiveEndUtc: string | null;
} {
  const isExtended = Boolean(rateData?.isExtended && rateData.effectiveEndUtc);
  return {
    isExtended,
    effectiveEndUtc: isExtended ? rateData!.effectiveEndUtc! : null,
  };
}
